export default "__VITE_ASSET__Crs3QPhf__"